import React,{useEffect} from "react";
// ,useState,useContext
//import { CopyToClipboard } from 'react-copy-to-clipboard';
import "./style.css";

import { Container, Row, Col, Modal, Dropdown, Badge, Table } from 'react-bootstrap';
// , Button, DropdownButton
import cloneDeep from 'lodash/cloneDeep';

import { get_current_unix_stamp } from "utils/Helper.js";

import UserContext from 'store/UserContext';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    style={{ color: "gray" }}
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

const last_active_lookback_time = 90; // seconds

function ChangeChatHostModal (props) {
  const user_context = React.useContext(UserContext);
  
  const [invite_users,setInviteUsers] = React.useState([]);
  const [chat_users,setChatUsers] = React.useState([]);

  function transferOwnership(user_obj) {
    console.log("transferOwnership",user_obj);
    if (props.onTransferOwnership) {
      props.onHide();
      props.onTransferOwnership(user_obj);
    }
  }
  
  function kickUser(user_obj) {
    console.log("kickUser",user_obj);
    if (props.onKickUser) {
      //props.onHide();
      props.onKickUser(user_obj);
    }
  }
  
  function inviteUser(user_obj) {
    console.log("inviteUser",user_obj);
    if (props.onInviteUser) {
      //props.onHide();
      props.onInviteUser(user_obj);
    }
  }
  
  useEffect(() => {
    console.log("ChangeChatHostModal useEffect user_context chat_info",user_context,props.chat_info);
    
    // setup users that we can invite
    let tmp_invite_users = [];
    let tmp_users_online = {};
    if (user_context.user_info.friends) {
      Object.values(user_context.user_info.friends).forEach( element => {
        if (element.is_online && element.last_active_time > (get_current_unix_stamp() - last_active_lookback_time)) {
          tmp_users_online[element.entity_uuid] = true;
          if (!props.chat_info.users || !props.chat_info.users.some( element2 => element2.entity_uuid === element.entity_uuid)) {
            element.indicator = <Badge pill variant="success">Online</Badge>;
            tmp_invite_users.push(element);
          }
          //if (!props.streamList.some( element2 => element2.uid === element.entity_uuid )) {
            //tmp_invite_users.push(element);
          //}
        }
      });
    }
    if (user_context.user_info.admins) {
      Object.values(user_context.user_info.admins).forEach( element => {
        if (element.is_online && element.last_active_time > (get_current_unix_stamp() - last_active_lookback_time)) {
          tmp_users_online[element.entity_uuid] = true;
          if (!props.chat_info.users || !props.chat_info.users.some( element2 => element2.entity_uuid === element.entity_uuid)) {
            if (!tmp_invite_users.some( element2 => element2.entity_uuid === element.entity_uuid)) {
              element.indicator = <Badge pill variant="success">Online</Badge>;
              tmp_invite_users.push(element);
            }
          }

          /*
          if (!props.streamList.some( element2 => element2.uid === element.entity_uuid )) {
            if (!tmp_invite_users.some( element2 => element2.entity_uuid === element.entity_uuid)) {
              tmp_invite_users.push(element);
            }
          }
          */
        }
      });
    }
    tmp_invite_users = tmp_invite_users
    setInviteUsers(tmp_invite_users);
    
    // setup users that are part of call already
    if (props.chat_info) {
      if (props.chat_info.users) {
        let tmp_chat_users = cloneDeep(props.chat_info.users);
        tmp_chat_users.forEach( element => {
          if (element.xref_data && element.xref_data.entity_owner_integer) {
            element.is_owner = true;
            if (props.streamList.some( element2 => element2.uid === element.entity_uuid )) {
              element.indicator = <Badge pill variant="success">Host - In Call</Badge>;
            } else {
              element.indicator = <Badge pill variant="success">Host</Badge>;
            }
          } else if (element.xref_data && element.xref_data.entity_reader_integer) {
            if (!props.streamList.some( element2 => element2.uid === element.entity_uuid )) {
              element.reinvite = true;
              if (tmp_users_online[element.entity_uuid]) {
                element.indicator = <React.Fragment><Badge pill variant="success">Online</Badge> <Badge pill variant="info">Invited</Badge></React.Fragment>;
              } else {
                element.indicator = <React.Fragment><Badge pill variant="warning">Offline</Badge> <Badge pill variant="info">Invited</Badge></React.Fragment>;
              }
            } else {
              element.participant = true;
              element.indicator = <Badge pill variant="success">In Call</Badge>;
            }
          } else if (element.xref_data && element.xref_data.joined_time) {
            // admins maybe who joined but were not invited
            if (!props.streamList.some( element2 => element2.uid === element.entity_uuid )) {
              element.reinvite = true;
              if (tmp_users_online[element.entity_uuid]) {
                element.indicator = <React.Fragment><Badge pill variant="success">Online</Badge></React.Fragment>;
              } else {
                element.indicator = <React.Fragment><Badge pill variant="warning">Offline</Badge></React.Fragment>;
              }
            } else {
              element.participant = true;
              element.indicator = <Badge pill variant="success">In Call</Badge>;
            }
          } else if (element.xref_data.kicked_time) {
            element.reinvite = true;
            element.indicator = <Badge pill variant="danger">Removed</Badge>;
          } else {
            // probably admin user who left
            element.hide = true;
          }
        });
        //tmp_chat_users = tmp_chat_users.filter( element => !element.hide);
        setChatUsers(tmp_chat_users);
      }
    }
  }, [props,user_context]);
  
  /*
  // on mount
  useEffect(() => {
    console.log("ChangeChatHostModal useEffect props.show",props.streamList);
    
    if (props.streamList.length > 0) {
      
    }

    //fetchData();
  }, [props.show]);
  */  


  
    return (
      <Modal
        style={{ color: 'black' }}
        show={props.show}
        onHide={props.onHide}
        //{...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          closeButton
          //style={{ justifyContent: "center",alignItems: "center" }}
        >
          <span style={{ fontSize: "larger", fontWeight: "bolder" }}>
            {props.chat_info.entity_name}
          </span>
        </Modal.Header>
        <Modal.Body>
          <Container>
            
            <Row style={{ marginBottom: "10px" }}>
              <Col>
              <Table
                striped
                //bordered
                hover
                //variant={user_context.theme === 'dark' ? 'dark' : ''}
              >
                <thead>
                  <tr>
                    <th>
                      <span style={{ fontSize: "large" }}>Chat Users</span>
                    </th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                { chat_users.map( user_element => (
                  <tr key={user_element.entity_uuid}>
                    <td>
                      
                      { user_element.adjusted_image_url &&
                        <img className="img-fluid rounded-circle" style={{ marginRight: "10px" }} width="25px" height="25px" src={user_element.adjusted_image_url} alt="friend avatar image" />
                      }
                      <span style={{ fontSize: "larger" }}>{user_element.entity_name}</span>
                    </td>
                    <td style={{ textAlign: "right",fontSize: "larger" }}>
                      {user_element.indicator}
                    </td>
                    <td style={{ fontSize: "larger" }}>
                      { !user_element.is_owner &&
                        <Dropdown>
                          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                            <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            { user_element.participant &&
                              <React.Fragment>
                                <Dropdown.Item onClick={() => kickUser(user_element)}>
                                  Remove User
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => transferOwnership(user_element)}>
                                  Make Host
                                </Dropdown.Item>
                              </React.Fragment>
                            }
                            { user_element.reinvite &&
                              <React.Fragment>
                                <Dropdown.Item onClick={() => inviteUser(user_element)}>
                                  Re-Invite User
                                </Dropdown.Item>
                              </React.Fragment>
                            }
                          </Dropdown.Menu>
                        </Dropdown>
                      }
                    </td>
                  </tr>
                ))}
                </tbody>
              </Table>
              </Col>
          </Row>

            <Row style={{ marginBottom: "10px" }}>
              <Col>
              <Table
                striped
                //bordered
                hover
                //variant={user_context.theme === 'dark' ? 'dark' : ''}
              >
                <thead>
                  <tr>
                    <th>
                      <span style={{ fontSize: "large" }}>Invite Users to Chat</span>
                    </th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                { invite_users.map( user_element => (
                  <tr key={user_element.entity_uuid}>
                    <td>
                      
                      { user_element.adjusted_image_url &&
                        <img className="img-fluid rounded-circle" style={{ marginRight: "10px" }} width="25px" height="25px" src={user_element.adjusted_image_url} alt="friend avatar image" />
                      }
                      <span style={{ fontSize: "larger" }}>{user_element.entity_name}</span>
                    </td>
                    <td style={{ textAlign: "right",fontSize: "larger" }}>
                      {user_element.indicator}
                    </td>
                    <td style={{ fontSize: "larger" }}>

                        <Dropdown>
                          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                            <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => inviteUser(user_element)}>
                              Invite User
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>

                    </td>
                  </tr>
                ))}
                </tbody>
              </Table>
              </Col>
          </Row>


          {/*
            <Row style={{ marginBottom: "10px" }}>
              <Col>
                Invite User To Chat:
              </Col>
              <Col>
                <DropdownButton
                  variant="pkprimary"
                  //disabled={this.state.button_loading}
                  //className="d-inline-block"
                  title="Select User to Invite"
                >
                  { invite_users.map( (element,index) => {
                    
                      return (
                        <Dropdown.Item
                          key={element.entity_uuid}
                          onClick={() => inviteUser(element)}
                        >
                          {element.entity_name}
                        </Dropdown.Item>  
                      );
                    
                  })}
                </DropdownButton>
              </Col>
            </Row>
          */}
            {/*
            { props.streamList.length > 1 &&
              <Row style={{ marginBottom: "10px" }}>
                <Col>
                  Remove User From Chat:
                </Col>
                <Col>
                  <DropdownButton
                    variant="pkprimary"
                    //disabled={this.state.button_loading}
                    //className="d-inline-block"
                    title="Select User to Kick"
                  >
                    { props.streamList.map( (stream_obj,index) => {
                      if (index !== 0) {
                        return (
                          <Dropdown.Item
                            key={stream_obj.uid}
                            onClick={() => kickUser(stream_obj.uid)}
                          >
                            {stream_obj.nickname}
                          </Dropdown.Item>  
                        );
                      }
                    })}
                  </DropdownButton>
                </Col>
              </Row>
            }
            { props.streamList.length > 1 &&
              <Row>
                <Col>
                  Transfer Chat Ownership:
                </Col>
                <Col>
                  <DropdownButton
                    variant="pkprimary"
                    //disabled={this.state.button_loading}
                    //className="d-inline-block"
                    title="Select New Owner"
                  >
                    { props.streamList.map( (stream_obj,index) => {
                      if (index !== 0) {
                        return (
                          <Dropdown.Item
                            key={stream_obj.uid}
                            onClick={() => transferOwnership(stream_obj)}
                          >
                            {stream_obj.nickname}
                          </Dropdown.Item>  
                        );
                      }
                    })}
                  </DropdownButton>
                </Col>
              </Row>
            }
            */}
          </Container>
        </Modal.Body>
        {/*
        <Modal.Footer>
          <Button
            className="modal_button_white"
            onClick={props.onHide}
          >
            Close
          </Button>
        </Modal.Footer>
        */}
      </Modal>
    );

}

export default ChangeChatHostModal;
